export default __webpack_public_path__ + "static/media/long.e21a5365.mp3";